"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DeliveryPromiseSaga_1 = require("../../deliveryPromise/sagas/DeliveryPromiseSaga");
const loadDeliveryPromiseModule = () => ({
    id: 'DeliveryPromise',
    sagas: [DeliveryPromiseSaga_1.default],
});
exports.default = loadDeliveryPromiseModule;
